export const POLICYHOLDER__POLICIES__TABLE_HEADER = 'Policies';
export const POLICYHOLDER__POLICIES__TABLE_ROW_ID = 'displayId';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_ID = 'Policy ID';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_ID_CLASSNAME =
	'policy_header__policy_id';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_ID_FIELD_NAME =
	'displayId';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_NAME = 'Policy Name';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_NAME_CLASSNAME =
	'policy_header__policy_name';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__POLICY_NAME_FIELD_NAME =
	'policyName';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__PRODUCT = 'Product';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__PRODUCT_CLASSNAME =
	'policy_header__product';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__PRODUCT_FIELD_NAME =
	'product';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__TERM = 'Term';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__TERM_CLASSNAME =
	'policy_header__term';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__TERM_FIELD_NAME =
	'startDate';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__CASH_BALANCE =
	'Cash Balance';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__CASH_BALANCE_CLASSNAME =
	'policy_header__cash_balance';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__CASH_BALANCE_FIELD_NAME =
	'cashBalanceAmount';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__STATUS = 'Status';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__STATUS_CLASSNAME =
	'policy_header__status';
export const POLICYHOLDER__POLICIES__TABLE_HEADER__STATUS_FIELD_NAME = 'status';

export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER = 'Applications';
export const POLICYHOLDER__APPLICATIONS__TABLE_ROW_ID = 'displayId';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__POLICY_ID = 'Policy ID';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__POLICY_ID_CLASSNAME =
	'application_header__policy_id';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__POLICY_ID_FIELD_NAME =
	'displayId';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__PRODUCT = 'Product';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__PRODUCT_CLASSNAME =
	'application_header__product';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__PRODUCT_FIELD_NAME =
	'product';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__DATE_CREATED =
	'Date Created';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__DATE_CREATED_CLASSNAME =
	'application_header__date_created';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__DATE_CREATED_FIELD_NAME =
	'dateCreated';

export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__STATUS = 'Status';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__STATUS_CLASSNAME =
	'application_header__status';
export const POLICYHOLDER__APPLICATIONS__TABLE_HEADER__STATUS_FIELD_NAME =
	'status';

export const POLICYHOLDER_INVOICE_VIEW__TITLE = 'Invoice';
export const POLICYHOLDER_INVOICE_VIEW__REVERSE_PAYMENT_BUTTON_TEXT =
	'Reverse Payment';
export const POLICYHOLDER_INVOICE_VIEW__PAY_INVOICE_BUTTON = 'Pay Invoice';
export const POLICYHOLDER_INVOICE_VIEW__DOWNLOAD_INVOICE_BUTTON =
	'Download Invoice';
export const POLICYHOLDER_INVOICE_VIEW__COPY_INVOICE_BUTTON =
	'Copy Invoice Locator';
export const POLICYHOLDER_INVOICE_VIEW__COPY_INVOICE_SUCCESS_TOAST =
	'Invoice locator copied to clipboard';
